import { BaseModel } from '../../_base/crud';

export class Client extends BaseModel {
  id: number;
  client_id: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  last_name2: string;
  domain: string;
  cell_phone: string;
  office_phone: string;
  fax: string;
  email: string;
  city: string;
  state: string;
  zip: string;
  address_1: string;
  address_2: string;
  communication_method: 'EMAIL' | 'FAX';
  order_status_update: boolean;
  remind_zero_refill: boolean;
  note: string;
  is_active: boolean;
  urbanization: any;
  type: 'PAYER' | 'MANUFACTURER';
  client_class: string;

  changeActiveStatus() {
    this.is_active = !this.is_active;
  }
}
